import { render, staticRenderFns } from "./SpeechInput.vue?vue&type=template&id=b595eda6&scoped=true&"
import script from "./SpeechInput.vue?vue&type=script&lang=js&"
export * from "./SpeechInput.vue?vue&type=script&lang=js&"
import style0 from "./SpeechInput.vue?vue&type=style&index=0&id=b595eda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b595eda6",
  null
  
)

export default component.exports